import { Anchor } from '@slal/ui/navigation';
import { useAnalytics } from '~/hooks';
import { Button } from '../Button';

export const Feedback = () => {
    const { pushEvent } = useAnalytics();
    const leaveFeedbackLabel = 'Leave feedback';
    return (
        <Anchor
            href="https://www.standardlife.co.uk/feedback/mib"
            target="_blank"
            onClick={() => pushEvent({ eventLabel: `${leaveFeedbackLabel} button click` })}
        >
            <Button>{leaveFeedbackLabel}</Button>
        </Anchor>
    );
};
